<fuse-drawer
  [sizeType]="'half'"
  [showUpBand]="true"
  [fixed]="true"
  [mode]="'over'"
  [name]="'rightDrawer'"
  [allowOutsideClick]="true"
  [opened]="openDrawer"
  [disableOverlayClick]="true"
  [position]="'right'"
  [transparentOverlay]="true"
  [_componentRef]="this"
  [drawerTemplateConfig]="mainDrawerTemplateConfig"
  (footerButtonClick)="onFooterButtonClickEvent($event)">
  <!-- Single content interface -->
  @switch (content) {
    @case ('rider') {
      <sbd-account-portal-frontend-rider-request
        [showHeader]="true"
        (moveBackEvent)="
          setContentContext('purchase-steps')
        "></sbd-account-portal-frontend-rider-request>
    }
    @case ('purchase-steps') {
      <sbd-account-portal-frontend-purchase-steps
        class="w-full h-full"
        [step]="step"
        [selectedQR]="selectedQR"
        [isPurchasing]="isPurchasing"
        [activeOpenedQR]="activeOpenedQR"
        [checkoutForm]="checkoutForm"
        [loggedInAccountUser]="loggedInAccountUser"
        [recentlyPurchasedCount]="recentlyPurchasedCount"
        [showCloseButton]="true"
        (closeDrawerEvent)="closeDrawer()"
        (updatedOpenQREvent)="updateSelectedQuoteOption($event)"
        (moveBackEvent)="onMoveBackEvent()"
        (moveToNextStepEvent)="onMoveToNextStepEvent()"
        (getShippingMethodValueEvent)="
          onGetShippingMethodValueEvent($event)
        "></sbd-account-portal-frontend-purchase-steps>
    }
  }
</fuse-drawer>
